<template>
  <div>
    <div v-if="ckmobile">
      <div class="pagination" v-if="$parent.$parent.isDesktop">
        <ul class="nonecolor" v-if="totalpages > 1">
          <li class="fbold" v-if="distrubutePg.length > 0">Pages &nbsp; &nbsp; </li>
          <li v-if="currentpage > 1">
            <router-link :to="{ path: $route.params.sid, query: { page:  1 }}" class="selectcolor"> << &nbsp;&nbsp;
            </router-link>
            <span @click="bquery(currentpage - 1)" class="selectcolor pointer"> Prev</span> &nbsp;&nbsp;
          </li>
          <li v-for="(n, x) in (distrubutePg)" v-if="x < showpgno">
            <span class="circle-icon pointer" @click="bquery(n+1)"
                  v-bind:class="{ active:  (n+1) == currentpage }">{{ n + 1 }}</span>
          </li>
           <li v-if="currentpage < distrubutePg.length + (currentpage - 3) && showpgno < totalpages"> ..</li>
          <li v-if="currentpage < distrubutePg.length + (currentpage - 3) &&  showpgno < totalpages">
            &nbsp;&nbsp; <span @click="bquery(currentpage + 1)" class="selectcolor pointer">  Next</span>
            <span @click="bquery(totalpages)" class="selectcolor pointer" :title="'lastpage-' + totalpages"> &nbsp;&nbsp; >> </span>
          </li>
        </ul>
      </div>
      <div class="mbPagination" v-else>
        <div class="pagination" v-if="totalpages > 1">
          <span@click="bquery(currentpage - 1)" class="selectcolor pointer" v-if="currentpage > 1"><i
          class="fa fa-angle-left"></i> Prev</span>
          <span @click="bquery(currentpage + 1)" class="selectcolor pointer" v-if="currentpage < totalpages">  Next <i
            class="fa fa-angle-right"></i></span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="pagination">
        <ul class="nonecolor" v-if="totalpages > 1">
          <li class="fbold" v-if="distrubutePg.length > 0 && $parent.$parent.isDesktop">Pages &nbsp; &nbsp; </li>
          <li v-if="currentpage > 1">
            <router-link :to="{ path: $route.params.sid, query: { page:  1 }}" class="selectcolor"> << &nbsp;&nbsp;
            </router-link>
            <span @click="bquery(currentpage - 1)" class="selectcolor pointer"> Prev</span> &nbsp;&nbsp;
          </li>
          <li v-for="(n, x) in (distrubutePg)" v-if="x < showpgno">
            <span class="circle-icon pointer" @click="bquery(n+1)"
                  v-bind:class="{ active:  (n+1) == currentpage }">{{ n + 1 }}</span>
          </li>
          <li v-if="currentpage < distrubutePg.length + (currentpage - 3) && showpgno < totalpages"> ..</li>
          <li v-if="currentpage < distrubutePg.length + (currentpage - 3) &&  showpgno < totalpages">
            &nbsp;&nbsp; <span @click="bquery(currentpage + 1)" class="selectcolor pointer">  Next</span>
            <span @click="bquery(totalpages)" class="selectcolor pointer"> &nbsp;&nbsp; >> </span>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    props: ['totalpages', 'currentpage', 'showpgno', 'ckmobile'],
    data () {
      return {
        fquery: this.$route.query
      }
    },
    methods: {
      bquery (pg) {
        this.$router.push({query: Object.assign({}, this.$route.query, {page: pg})})
      }
    },
    computed: {
      distrubutePg: function () {
        var marr = []
        var total = this.totalpages
        for (var i = 0; i < total; i++) {
          marr.push(i)
        }
        if ((marr.length) > this.showpgno) {
          marr.splice(0, this.currentpage - 3)
        }
        return marr
      }
    }
  }
</script>
<style scoped>
  @media screen and (max-width: 991px) {
    .mbPagination {
      text-align: right;
      float: right;
    }

    .mbPagination span {
      display: inline-block;
      margin: 0 5px;
    }
  }
</style>




// WEBPACK FOOTER //
// listingPagination.vue?5459e354